import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React, { useRef } from 'react';
import { PickersDay } from '@mui/x-date-pickers-pro';
import { DateRangePicker as DateRangePicker$1 } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import classNames from 'classnames';
import { getStatusIcon, ChevronUpIcon, ChevronDownIcon, ChevronRightIcon, ChevronLeftIcon } from '@cognite/cogs-icons';
import { IconWrapper } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Body } from '../../tokens/typography/typography.js';
import { COGS_DEFAULT_DATE_FORMAT } from '../../util/constants.js';
import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.string.replace.js';
import 'dayjs';
import { TextLabel } from '../_technical/text-label/text-label.js';
import 'core-js/modules/es.array.map.js';
import '@mui/base/Button';
import 'core-js/modules/es.array.push.js';
import '@mui/material';
import '@mui/material/Fade';
import { useConfigContextLoose } from '../config-provider/config-provider.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { Button } from '../button/button.js';
import { DATEPICKER_POPPER_BASE_MODIFIERS } from '../date-picker/constants.js';
import { LocalizationProvider } from '../localization-provider/localization-provider.js';
import { DateRangeButtonField } from './date-range-picker-button.js';

/**
 * `DateRangePicker` component lets the user select a range of dates.
 */
var DateRangePicker = /*#__PURE__*/React.forwardRef(function (_a, outerRef) {
  var _b;
  var disabled = _a.disabled,
    disablePopperPortal = _a.disablePopperPortal,
    format = _a.format,
    fullWidth = _a.fullWidth,
    helpText = _a.helpText,
    id = _a.id,
    label = _a.label,
    localizationProviderProps = _a.localizationProviderProps,
    _a$size = _a.size,
    size = _a$size === undefined ? 'medium' : _a$size,
    status = _a.status,
    statusText = _a.statusText,
    _a$variant = _a.variant,
    variant = _a$variant === undefined ? 'outline' : _a$variant,
    className = _a.className,
    dataTestId = _a['data-testid'],
    shortcuts = _a.shortcuts,
    actionBar = _a.actionBar,
    actionBarProps = _a.actionBarProps,
    buttonTriggerer = _a.buttonTriggerer,
    buttonTriggererProps = _a.buttonTriggererProps,
    popperContainer = _a.popperContainer,
    popperAnchor = _a.popperAnchor,
    otherProps = __rest(_a, ["disabled", "disablePopperPortal", "format", "fullWidth", "helpText", "id", "label", "localizationProviderProps", "size", "status", "statusText", "variant", "className", 'data-testid', "shortcuts", "actionBar", "actionBarProps", "buttonTriggerer", "buttonTriggererProps", "popperContainer", "popperAnchor"]);
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  var innerRef = useRef(null);
  var ref = outerRef || innerRef;
  var shouldDisplayLabel = !!label && variant !== 'ghost';
  var Icon = getStatusIcon(status);
  var _useConfigContextLoos = useConfigContextLoose(),
    dateFormat = _useConfigContextLoos.dateFormat;
  var formatLocal = (_b = format !== null && format !== undefined ? format : dateFormat) !== null && _b !== undefined ? _b : COGS_DEFAULT_DATE_FORMAT;
  /**
   * setting up configurations for buttonTriggered DateRangePicker
   */
  var extendedButtonTriggererProps = buttonTriggerer ? {
    field: Object.assign(Object.assign({}, buttonTriggererProps), {
      handleClick: function handleClick(e) {
        var _a;
        setOpen(function (prev) {
          return !prev;
        });
        (_a = buttonTriggererProps === null || buttonTriggererProps === undefined ? undefined : buttonTriggererProps.onClick) === null || _a === undefined ? undefined : _a.call(buttonTriggererProps, e);
      }
    })
  } : {};
  var buttonTriggererOptions = buttonTriggerer ? {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    onOpen: function onOpen() {
      return setOpen(true);
    }
  } : {};
  var customPopperContainerSetting = popperContainer ? {
    container: popperContainer
  } : {};
  var customPopperAnchorSetting = popperAnchor ? {
    anchorEl: popperAnchor
  } : {};
  return jsx(LocalizationProvider, {
    localizationProviderProps: localizationProviderProps,
    children: jsxs("div", {
      className: classNames('cogs-v10', 'cogs-daterangepicker-container', 'cogs-input-container', fullWidth && 'cogs-daterangepicker-container--full-width'),
      "data-testid": dataTestId,
      children: [shouldDisplayLabel && (typeof label === 'string' ? jsx(TextLabel, {
        htmlFor: id,
        text: label
      }) : jsx(TextLabel, Object.assign({
        htmlFor: id
      }, label))), jsx(DateRangePicker$1, Object.assign({}, otherProps, {
        className: className,
        disabled: disabled,
        format: formatLocal,
        ref: ref,
        slots: {
          day: function day(_a) {
            _a.isVisuallySelected;
              var isHighlighting = _a.isHighlighting,
              isStartOfHighlighting = _a.isStartOfHighlighting,
              isEndOfHighlighting = _a.isEndOfHighlighting,
              isPreviewing = _a.isPreviewing,
              isStartOfPreviewing = _a.isStartOfPreviewing,
              isEndOfPreviewing = _a.isEndOfPreviewing,
              isFirstVisibleCell = _a.isFirstVisibleCell,
              isLastVisibleCell = _a.isLastVisibleCell,
              props = __rest(_a, ["isVisuallySelected", "isHighlighting", "isStartOfHighlighting", "isEndOfHighlighting", "isPreviewing", "isStartOfPreviewing", "isEndOfPreviewing", "isFirstVisibleCell", "isLastVisibleCell"]);
            return jsx(PickersDay, Object.assign({
              isFirstVisibleCell: true,
              isLastVisibleCell: true
            }, props, {
              className: classNames('cogs-v10', 'cogs-daterangepicker-day', isHighlighting && 'cogs-daterangepicker-day--highlighting', isStartOfHighlighting && 'cogs-daterangepicker-day--highlighting--start', isEndOfHighlighting && 'cogs-daterangepicker-day--highlighting--end', isPreviewing && 'cogs-daterangepicker-day--previewing', isStartOfPreviewing && 'cogs-daterangepicker-day--previewing--start', isEndOfPreviewing && 'cogs-daterangepicker-day--previewing--end', isFirstVisibleCell && 'cogs-daterangepicker-day--first-visible', isLastVisibleCell && 'cogs-daterangepicker-day--last-visible', props.className),
              disableRipple: true
            }));
          },
          field: buttonTriggerer ? DateRangeButtonField : SingleInputDateRangeField,
          switchViewButton: function switchViewButton(props) {
            var _a;
            return jsx(Button, {
              "aria-label": "Switch date picker view",
              icon: ((_a = props === null || props === undefined ? undefined : props.ownerState) === null || _a === undefined ? undefined : _a.view) !== 'day' ? jsx(ChevronUpIcon, {}) : jsx(ChevronDownIcon, {}),
              size: "small",
              type: "ghost"
            });
          },
          nextIconButton: function nextIconButton(props) {
            var _a;
            return jsx(Button, {
              "aria-label": "Go to next month",
              className: classNames('cogs-v10', ((_a = props.ownerState) === null || _a === undefined ? undefined : _a.isNextHidden) && 'cogs-daterangepicker-iconbutton--hidden'),
              disabled: props === null || props === undefined ? undefined : props.disabled,
              onClick: props === null || props === undefined ? undefined : props.onClick,
              icon: jsx(ChevronRightIcon, {}),
              size: "small",
              type: "ghost"
            });
          },
          previousIconButton: function previousIconButton(props) {
            var _a;
            return jsx(Button, {
              "aria-label": "Go to previous month",
              className: classNames('cogs-v10', ((_a = props.ownerState) === null || _a === undefined ? undefined : _a.isPreviousHidden) && 'cogs-daterangepicker-iconbutton--hidden'),
              disabled: props === null || props === undefined ? undefined : props.disabled,
              onClick: props === null || props === undefined ? undefined : props.onClick,
              icon: jsx(ChevronLeftIcon, {}),
              size: "small",
              type: "ghost"
            });
          },
          actionBar: actionBar
        },
        slotProps: Object.assign({
          layout: {
            className: classNames('cogs-v10', otherProps.displayWeekNumber && 'cogs-daterangepicker-displayweeknumber')
          },
          desktopPaper: {
            className: 'cogs-v10 cogs-daterangepicker-desktoppaper'
          },
          popper: Object.assign(Object.assign({
            className: 'cogs-v10 cogs-daterangepicker-popper',
            disablePortal: disablePopperPortal,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- types don't accept data-testid prop even though it is applied
            // @ts-ignore
            'data-testid': 'cogs-daterangepicker-popper',
            modifiers: [].concat(DATEPICKER_POPPER_BASE_MODIFIERS)
          }, customPopperContainerSetting), customPopperAnchorSetting),
          textField: {
            className: classNames('cogs-v10', 'cogs-daterangepicker', fullWidth && 'cogs-input-container-full-width'),
            hiddenLabel: true,
            id: id,
            InputProps: {
              className: classNames('cogs-v10', 'cogs-input', "cogs-input--size-" + size, "cogs-input--variant-" + variant, "cogs-input--status-" + status, 'cogs-input-with-no-right-padding', disabled && "cogs-input-disabled", fullWidth && "cogs-input-full-width")
            }
          },
          shortcuts: {
            className: 'cogs-v10 cogs-daterangepicker-shortcuts',
            items: shortcuts,
            changeImportance: 'set'
          },
          actionBar: actionBarProps
        }, extendedButtonTriggererProps),
        closeOnSelect: !actionBar
      }, buttonTriggererOptions)), helpText && jsx(Body, {
        className: "cogs-v10 cogs-input-help-text",
        size: "x-small",
        children: helpText
      }), status && statusText && jsxs("div", {
        className: "cogs-v10 cogs-input-status-text-container",
        children: [Icon && jsx(IconWrapper, {
          size: 12,
          children: jsx(Icon, {
            className: classNames('cogs-v10', 'cogs-input-status-text', "cogs-input-status-text--status-" + status)
          })
        }), jsx(Body, {
          className: classNames('cogs-v10', 'cogs-input-status-text', "cogs-input-status-text--status-" + status),
          size: "x-small",
          children: statusText
        })]
      })]
    })
  });
});

export { DateRangePicker };
